/* PDP "Shipping" accordion behaviour (snippets/product-shipping-accordion.liquid). No jQuery.
   - ZIP estimator locked to this product's ship type (zone + windows from the shipping page's
     block settings; expedited line for Central/Eastern week-format windows, as the page's tool).
   - Coverage maps fetched from the theme assets and inlined into shadow roots (same mechanism as
     sections/shipping-policy-page.liquid: CORS-friendly CDN, shadow isolation keeps the maps'
     two-letter classes from colliding); <object> stays as the no-JS fallback. World map lazy on
     the first International tab click. Hover / tap tooltip shows THIS product's window per region.
   - Re-measures the accordion's max-height after anything grows it (the accordion script sets an
     inline max-height at open time; late-arriving maps or the estimator output would be clipped). */
(function () {
  'use strict';
  var US_WEST = ['wa', 'or', 'ca', 'nv', 'id', 'mt', 'wy', 'ut', 'co', 'az', 'nm', 'nd'];
  var US_CENTRAL = ['sd', 'ne', 'ks', 'mn', 'ia', 'mo', 'wi', 'il', 'mi', 'in', 'oh', 'ky', 'ok', 'tx', 'ar', 'la'];
  var EU = ['at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se'];
  var SEA = ['bn', 'kh', 'id', 'la', 'my', 'mm', 'ph', 'sg', 'th', 'tl', 'vn'];
  var SERVED = { ca: 'canada', gb: 'east', au: 'west', us: 'us' };
  EU.forEach(function (c) { SERVED[c] = 'east'; });
  SEA.forEach(function (c) { SERVED[c] = 'west'; });
  var ZONE_LABEL = { west: 'Western US', central: 'Central US', east: 'Eastern US' };
  /* first digit 0-3 East, 4-7 Central, 8-9 West; 58x/59x (ND/MT) are West */
  var zoneOf = function (zip) {
    var d = zip.charAt(0), d2 = parseInt(zip.slice(0, 2), 10);
    if (d === '5' && d2 >= 58) return 'west';
    if ('0123'.indexOf(d) !== -1) return 'east';
    if ('4567'.indexOf(d) !== -1) return 'central';
    return 'west';
  };

  function init(root) {
    if (!root || root.hasAttribute('data-shipacc-ready')) return;
    root.setAttribute('data-shipacc-ready', '');
    var d = root.dataset;
    var isQS = d.type === 'qs';
    var tip = document.querySelector('[data-shipacc-tip]');
    var showTip = function (html, x, y) {
      if (!tip) return;
      tip.innerHTML = html; tip.hidden = false;
      tip.style.left = Math.min(x + 16, window.innerWidth - 310) + 'px';
      tip.style.top = (y + 18) + 'px';
    };
    var hideTip = function () { if (tip) tip.hidden = true; };
    window.addEventListener('scroll', function () { if (tip && !tip.hidden) hideTip(); }, { passive: true });
    document.addEventListener('pointerdown', function (e) {
      if (!tip || tip.hidden) return;
      var path = e.composedPath ? e.composedPath() : [];
      for (var i = 0; i < path.length; i++) {
        if (path[i].classList && path[i].classList.contains('ag-shipacc-maphost')) return;
      }
      hideTip();
    });

    /* the accordion script sets body.style.maxHeight at open; keep it honest when we grow */
    var body = root.closest('.product-overview_acc-body');
    var resize = function () {
      if (!body) return;
      if (body.style.maxHeight && body.style.maxHeight !== '0px') body.style.maxHeight = body.scrollHeight + 'px';
    };

    /* ---- estimator ---- */
    var zip = root.querySelector('[data-shipacc-zip]');
    var out = root.querySelector('[data-shipacc-out]');
    var go = root.querySelector('[data-shipacc-go]');
    var estimate = function () {
      var v = (zip.value || '').trim();
      if (!/^[0-9]{5}$/.test(v)) {
        out.innerHTML = 'Enter a 5-digit US ZIP code. Outside the US? Your quote carries the confirmed window.';
        resize(); return;
      }
      var z = zoneOf(v), est = d[z] || '', exp = '';
      var m = /^(\d+) to (\d+) weeks$/.exec(est);
      if (m && (z === 'central' || z === 'east')) {
        var cut = z === 'central' ? 1 : 2;
        exp = '<br><strong>Expedited delivery:</strong> ' + Math.max(1, parseInt(m[1], 10) - cut) + ' to ' + Math.max(1, parseInt(m[2], 10) - cut) + ' weeks';
      }
      out.innerHTML = '<strong>Standard delivery to ' + v + ' (' + ZONE_LABEL[z] + '):</strong> ' + est + exp +
        '<span class="ag-shipacc-tool-note">You will receive a more specific date window closer to the delivery date.</span>';
      resize();
    };
    if (zip && out && go) {
      go.addEventListener('click', estimate);
      zip.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); estimate(); } });
    }

    /* ---- maps ---- */
    var rowHtml = function (val) { return '<p><strong>' + d.label + ':</strong> ' + val + '</p>'; };
    var shell = function (title, bodyHtml) { return '<p class="ag-shipacc-tip-title">' + title + '</p><div class="ag-shipacc-tip-body">' + bodyHtml + '</div>'; };
    var usTip = function (t) {
      var cls = t.getAttribute && t.getAttribute('class'); if (!cls) return null;
      var code = cls === 'dccircle' ? 'dc' : cls; if (!/^[a-z]{2}$/.test(code)) return null;
      var te = t.querySelector && t.querySelector('title'); var name = te ? te.textContent : 'This state';
      var region = US_WEST.indexOf(code) !== -1 ? 'west' : (US_CENTRAL.indexOf(code) !== -1 ? 'central' : 'east');
      var exp = region === 'central' ? '7 days' : (region === 'east' ? '14 days' : null);
      var foot = exp
        ? (isQS ? 'Expedited delivery available.' : 'Expedited delivery available: takes ' + exp + ' off total delivery.')
        : 'Standard shipping only.';
      return shell(name + ' &middot; ' + ZONE_LABEL[region], rowHtml(d[region]) + '<p class="ag-shipacc-tip-foot">' + foot + '</p>');
    };
    var worldTip = function (t) {
      if (!t.getAttribute) return null;
      var cls = t.getAttribute('class') || '';
      if (cls.indexOf('oceanxx') !== -1 || cls.indexOf('antxx') !== -1) return null;
      var ex = t.getAttribute('data-ag-excluded');
      if (ex) return shell(ex, '<p>We don&rsquo;t ship to ' + ex + ' right now.</p>');
      var el = t, id = null;
      while (el && el.getAttribute) { var eid = el.getAttribute('id'); if (eid && /^[a-z]{2}$/.test(eid)) { id = eid; break; } el = el.parentNode; }
      if (!id && cls.indexOf('landxx') === -1) return null;
      var te = (t.querySelector && t.querySelector('title')) || (el && el.getElementsByTagName ? el.getElementsByTagName('title')[0] : null);
      var name = te ? te.textContent : 'this country';
      var s = id && SERVED[id];
      if (!s) return shell(name, '<p>We don&rsquo;t ship to ' + name + ' right now.</p>');
      if (s === 'us') return shell('United States', rowHtml(d.west === d.east ? d.west : d.west.replace(/ to .*$/, '') + ' to ' + d.east.replace(/^.* to /, '')) + '<p class="ag-shipacc-tip-foot">48 contiguous states; ranges vary by region. Switch to the United States view for state detail.</p>');
      if (s === 'canada') return shell('Canada', rowHtml('Western Canada ' + d.intlWest + ', Eastern Canada ' + d.intlEast) + '<p class="ag-shipacc-tip-foot">Varies by coast.</p>');
      return shell(name, rowHtml(s === 'west' ? d.intlWest : d.intlEast));
    };
    var inlineMap = function (host) {
      if (!host || host.shadowRoot || !window.fetch || !Element.prototype.attachShadow) return;
      var kind = host.getAttribute('data-shipacc-kind');
      var src = kind === 'us' ? d.usSrc : d.worldSrc;
      fetch(src)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (txt) {
          var svg = txt.replace(/^[\s\S]*?(<svg)/, '$1');
          var sh = host.attachShadow({ mode: 'open' });
          sh.innerHTML = svg + '<style>svg{width:100%;height:auto;display:block}path{cursor:default}path:hover{fill-opacity:0.82}' +
            (kind === 'us'
              ? '.wa,.or,.ca,.nv,.id,.mt,.wy,.ut,.co,.az,.nm,.nd{fill:#465849;fill-opacity:0.5}.wa:hover,.or:hover,.ca:hover,.nv:hover,.id:hover,.mt:hover,.wy:hover,.ut:hover,.co:hover,.az:hover,.nm:hover,.nd:hover{fill-opacity:0.62}'
              : '') + '</style>';
          var onPoint = function (e) {
            var t = e.composedPath()[0];
            var html = kind === 'us' ? usTip(t) : worldTip(t);
            if (html) showTip(html, e.clientX, e.clientY); else hideTip();
          };
          host.addEventListener('pointermove', onPoint);
          host.addEventListener('pointerdown', onPoint);
          host.addEventListener('pointerleave', hideTip);
          resize();
        })
        .catch(function () {
          var obj = host.querySelector('object[data-src]');
          if (obj) { obj.setAttribute('data', obj.getAttribute('data-src')); obj.removeAttribute('data-src'); }
          resize();
        });
    };
    inlineMap(root.querySelector('[data-shipacc-kind="us"]'));
    var tabs = root.querySelectorAll('.ag-shipacc-maptab');
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabs.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        root.querySelectorAll('.ag-shipacc-map').forEach(function (p) {
          if (p.getAttribute('data-shipacc-panel') === btn.getAttribute('data-shipacc-map')) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
        hideTip();
        if (btn.getAttribute('data-shipacc-map') === 'world') inlineMap(root.querySelector('[data-shipacc-kind="world"]'));
        resize();
      });
    });
    /* the accordion may open after the maps arrived: re-measure once it does */
    if (body && window.MutationObserver) {
      new MutationObserver(function () { setTimeout(resize, 350); }).observe(body, { attributes: true, attributeFilter: ['style'] });
    }
  }

  var boot = function () { document.querySelectorAll('[data-shipacc]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
